(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-payout-chart-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-payout-chart-container.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioButton = _svs$ui$reactForm.RadioButton,
  RadioGroup = _svs$ui$reactForm.RadioGroup;
const Paper = svs.ui.ReactPaper;
const PAYOUT_KEYS = svs.lyckoplatsen.components.shared_constants.CONSTANTS.PAYOUT_KEYS;
const CharityPayoutChart = svs.lyckoplatsen.components.shared_charity_payout.react.components.CharityPayoutChart;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const charityPayoutsAtom = svs.lyckoplatsen.shared_charity_payout.jotai.atoms.charityPayoutsAtom;
const doesPayoutChartContainData = svs.lyckoplatsen.shared_charity_payout.utils.doesPayoutChartContainData;
const latestPrimaryDraw = svs.lyckoplatsen.data.latestPrimaryDraw;
const currentYear = new Date().getFullYear();
const selectedPayoutText = {
  [PAYOUT_KEYS.LATEST_DRAW]: latestPrimaryDraw ? "Vecka ".concat(svs.utils.date.WeekNr(latestPrimaryDraw.regCloseTime)) : '',
  [PAYOUT_KEYS.THIS_YEAR]: "Hela ".concat(currentYear),
  [PAYOUT_KEYS.SINCE_LAUNCH]: "2025 - ".concat(currentYear)
};
const CharityPayoutChartContainer = _ref => {
  var _charityPayouts$payou;
  let payoutKey = _ref.payoutKey,
    handlePayoutKeyChange = _ref.handlePayoutKeyChange;
  const charityPayouts = useAtomValue(charityPayoutsAtom);
  const payoutChartData = (_charityPayouts$payou = charityPayouts[payoutKey]) === null || _charityPayouts$payou === void 0 ? void 0 : _charityPayouts$payou.data;
  const _useState = useState(svs.core.detect.breakpoint.greaterThan('xs')),
    _useState2 = _slicedToArray(_useState, 2),
    isHorizontal = _useState2[0],
    setIsHorizontal = _useState2[1];
  useEffect(() => {
    const listener = () => {
      if (svs.core.detect.breakpoint.lessThan('sm')) {
        setIsHorizontal(false);
      } else {
        setIsHorizontal(true);
      }
    };
    svs.core.detect.breakpoint.on('change', listener);
    return () => svs.core.detect.breakpoint.off('change', listener);
  }, []);
  if (!doesPayoutChartContainData(charityPayouts[PAYOUT_KEYS.SINCE_LAUNCH])) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-charity-payout-chart-container charity-grid padding-top-1 padding-bottom-1"
  }, React.createElement("div", {
    className: "charity-grid-body"
  }, React.createElement(Paper, null, React.createElement("div", {
    className: "chartity-container-top"
  }, React.createElement("p", {
    className: "top-header"
  }, "F\xF6rdelning av bidrag"), React.createElement("p", null, selectedPayoutText[payoutKey])), React.createElement("div", {
    className: "charity-toggle-wrapper"
  }, React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, React.createElement(RadioButton, {
    onChange: handlePayoutKeyChange,
    value: PAYOUT_KEYS.LATEST_DRAW,
    defaultChecked: true
  }, "Dragning"), React.createElement(RadioButton, {
    onChange: handlePayoutKeyChange,
    value: PAYOUT_KEYS.THIS_YEAR
  }, "\xC5r ", currentYear), React.createElement(RadioButton, {
    onChange: handlePayoutKeyChange,
    value: PAYOUT_KEYS.SINCE_LAUNCH
  }, "Sedan start"))), React.createElement(CharityPayoutChart, {
    payoutChartData: payoutChartData,
    fontColor: "black",
    horizontal: isHorizontal
  }))));
};
setGlobal('svs.lyckoplatsen.components.page_charity_payout.react.components', {
  CharityPayoutChartContainer
});

 })(window);